import React from 'react';

import { motion } from 'framer-motion';
import { useModal } from '../Components/Modal/ModalContext';
import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import HeaderPanel from '../Components/HeaderPanel';
import LoadingLines from '../Components/LoadingLines';
import Loading from '../Components/Loading';
import NewCardOfCase from '../Components/CardOfCase';

const Testing = () => {
    const { openModal } = useModal();
    const { openTimeModal } = useTimeModal();

    const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);
    const [idCaseForModal, setIdCaseForModal] = React.useState('');

    const [contentt, setContentt] = React.useState('');

    return (
        <>
        {isCardOfCaseModal && <NewCardOfCase closeModal={() => {setIsCardOfCaseModal(false)}} id={idCaseForModal} onCardOfCaseSuccess={() => {}} />}

        <div className='mainContainer'>
            <h1>Тестирование системы</h1>
            <HeaderPanel typePanel='Назад' />
            <div style={{marginTop: '7px'}}></div>
            <a className='button' style={{width: 'fit-content'}} onClick={() => openModal('Тест заголовка', 'Тестирование постоянного модального окна')}>Открыть модально окно</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно warning', 'warning');}}>Открыть временное модально окно warning</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно error', 'error');}}>Открыть временное модально окно error</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Временное модальное окно success', 'success');}}>Открыть временное модально окно success</a>
            <a className='button' style={{width: 'fit-content'}} onClick={() => {openTimeModal('Слово', 'success');}}>Открыть временное модальное окно success с малым содержимым</a>
            <div><h2>Тестовая разметка писем</h2></div>
            <div style={{margin: '10px 0', backgroundColor: '#F5F8FA'}}>
                <div style={{width: '440px', backgroundColor: 'white', padding: '0 20px', margin: '0 auto', boxSizing: 'border-box'}}>
                    <div style={{padding: '24px 0'}}>
                        <img style={{height: '40px'}} src='/img/logo/mainlogo-without-text-375.png' alt='Значок приложения Поток' />
                    </div>
                    <div style={{}}>
                        <h1 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '24px'}}>После проведения собрания СОАУ «Альянс» назначила вас арбитражным управляющим на следующее дело.</h1>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                        <h2 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '16px'}}>Вы прикреплены в системе к делу #А32904/83/02</h2>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                            <h2 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '16px'}}>Краткая информация:</h2>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                            <h2 style={{width: '40%', fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Должник</h2>
                            <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Praha, Česká republika</a>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                            <h2 style={{width: '40%', fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Комментарий от СОАУ «Альянс»</h2>
                            <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Отсутствует</a>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 5px 0'}}>
                            <h2 style={{width: '40%', fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Местоположение*</h2>
                            <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Praha, Česká republika</a>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                        <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 10px 0'}}>
                            <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Теперь есть возможность управлять ведением дела в системе по кнопке ниже.</a>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', margin: '12px 0'}}>
                        <h2 style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '16px'}}>Если вы считаете это действие ошибочным</h2>
                        <div style={{display: 'flex', justifyContent: 'space-between', margin: '5px 0 10px 0'}}>
                            <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '15px'}}>Отправьте письмо на следующий адрес электронной почты: schepetov_av@mail.ru</a>
                        </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '12px 0'}}>
                        <a style={{padding: '5px 20px', backgroundColor: 'black', color: 'white', fontSize: '15px', fontWeight: '600', cursor: 'pointer', borderRadius: '3px'}}>Перейти</a>
                    </div>
                    <div style={{padding: '30px 0', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                        <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '12px', color: '#8899a6', textAlign: 'center'}}>Это сообщение о важных событиях в вашей учётной записи системы «Поток».</a>
                        <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '12px', color: '#8899a6', textAlign: 'center'}}>Вы можете отказаться от уведомлений в настройках.</a>
                        <a style={{fontFamily: "'HelveticaNeue', 'Helvetica Neue', Helvetica, Arial, sans-serif'", fontSize: '12px', color: '#8899a6', textAlign: 'center'}}>© 2025 СОАУ «Альянс», 603000, г. Нижний Новгород, ул. Горького, д. 52, помещение П2</a>
                    </div>
                </div>
            </div>
            <div class="glow-effect">
                Это объект с анимацией тени
            </div>
            <LoadingLines />
            <Loading />
            <div className='skeletonBox'></div>

            <a type='button' style={{width: 'fit-content'}} className='button' onClick={() => {setIsCardOfCaseModal(true); setIdCaseForModal(175)}}>Тест нового окна карточки дела</a>


            <div style={{boxShadow: '0 0 0 1px #e5e5e5', padding: '10px', borderRadius: '.5em', margin: '10px 0'}}>
                <a className='button' onClick={() => {setContentt('Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. LoremLorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. LoremLorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem')}}>Добавить содержимое</a>
                <a className='button' onClick={() => {setContentt('')}}>Убрать содержимое</a>
                <a>Начальный контент</a>
                <motion.div
                    initial={{ scale: '97%', opacity: 0 }}
                    animate={{ scale: '100%', opacity: 1 }}
                    transition={{ duration: 0.5 }}
                    style={{ overflow: "hidden", background: "#eee" }}
                >
                    <h1>{contentt}</h1>
                </motion.div>
            </div>
            <motion.div
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                transition={{ duration: 0.5 }}
                style={{ overflow: "hidden", background: "#eee" }}
            >
                <p>Анимированный контент</p>
            </motion.div>
            
            <table className='mainTable'>
                <thead>
                    <tr>
                        <th>Имя</th>
                        <th>Возраст</th>
                        <th>Город</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td data-label="Имя">Иван</td>
                        <td data-label="Возраст">25</td>
                        <td data-label="Город">Москва</td>
                    </tr>
                    <tr>
                        <td data-label="Имя">Мария</td>
                        <td data-label="Возраст">30</td>
                        <td data-label="Город">Санкт-Петербург</td>
                    </tr>
                    <tr>
                        <td data-label="Имя">Алексей</td>
                        <td data-label="Возраст">28</td>
                        <td data-label="Город">Казань</td>
                    </tr>
                </tbody>
            </table>
            <h1>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem</h1>
            <h1>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem</h1>
            <h1>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Perferendis pariatur placeat sunt porro hic? Cum id at atque, nulla officiis deserunt nobis ipsam, magni, sit dolorem esse ipsa eveniet reprehenderit. Lorem</h1>
        </div>
        </>
    )
}

export default Testing;